import React from "react";

import { AccordionDetails, Chip, Grid } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { isMobile } from "react-device-detect";

import { getSearchedGamesStart } from "../../../../../../redux-saga/redux/casino/lobby/casinoGames";
import useStyles from "./Sections.styles";

const ProviderSection = ({
  offset,
  searchInput,
  selectedCategory,
  selectedProvider,
  removeSelectedItem,
  setProvider
}) => {
  const classes = useStyles();
  const { providers } = useSelector((state) => state.casinoLobby);
  const dispatch = useDispatch();

  const handleProvider = (id, name) => {
    offset.current = 1;
    if (selectedProvider[id]) {
      removeSelectedItem(`provider,${id}`);
      return;
    }
    setProvider(id, name);
    let filters = {
      isMobile,
      page: 1,
      limit: isMobile ? 8 : 12,
      search: searchInput.trim().length ? searchInput : null
    };
    filters.providerId = JSON.stringify([
      ...Object.keys(selectedProvider),
      `${id}`
    ]);
    let categories = Object.keys(selectedCategory);
    if (categories.length > 0) {
      filters.subCategoryId = JSON.stringify(categories);
    }
    dispatch(
      getSearchedGamesStart({
        ...filters
      })
    );
  };

  return (
    <>
      <AccordionDetails className={classes.accordiondetails}>
        <Grid className={classes.chipcontainer}>
          {providers?.provider?.length > 0
            ? providers?.provider?.map((item) => {
                return (
                  <Chip
                    color={
                      selectedProvider[item.masterCasinoProviderId]
                        ? "primary"
                        : "default"
                    }
                    label={item.name}
                    key={item.providerId}
                    clickable
                    onClick={() =>
                      handleProvider(item.masterCasinoProviderId, item.name)
                    }
                  />
                );
              })
            : null}
        </Grid>
      </AccordionDetails>
    </>
  );
};

export default ProviderSection;
